export default () => ({
  gibAirRate: {},
});
